module.exports = __webpack_public_path__ + "static/img/platform_bg.00b767c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/platform_bg.png
// module id = DyJ+
// module chunks = 1